module.exports = __webpack_public_path__ + "static/media/Mobile_Data_GOVERNANCA_CORPORATIVA_E_TI.1a34f383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/governanca/Mobile_Data_GOVERNANCA_CORPORATIVA_E_TI.png
// module id = 96
// module chunks = 0